import { ethers } from 'ethers';
import { DposInterface } from '../typechain-types/dpos_contract_interface.sol/DposInterface';
import { DposInterface__factory } from '../typechain-types/factories/dpos_contract_interface.sol/DposInterface__factory';
import { DPOS_CONTRACT_ADDRESS, TARGET_VALIDATOR } from '../config/networkConfig';

// Interface to represent each individual validator delegation
export interface ValidatorDelegation {
  address: string;
  amount: bigint;
  rewards: bigint;
}

export interface DelegationSummary {
  targetValidatorAmount: bigint;
  otherValidatorsAmount: bigint;
  targetValidatorRewards: bigint;
  // Add array of other validators with their delegation amounts
  otherValidators: ValidatorDelegation[];
  isLoading: boolean;
}

class DelegationServiceClass {
  private contract: DposInterface | null = null;
  
  constructor(provider?: ethers.Provider) {
    if (provider) {
      this.initContract(provider);
    }
  }

  public initContract(provider: ethers.Provider) {
    this.contract = DposInterface__factory.connect(DPOS_CONTRACT_ADDRESS, provider);
  }

  public async getDelegationSummary(delegatorAddress: string): Promise<DelegationSummary> {
    if (!this.contract) {
      throw new Error('Contract not initialized. Call initContract first.');
    }

    try {
      let targetValidatorAmount = BigInt(0);
      let otherValidatorsAmount = BigInt(0);
      let targetValidatorRewards = BigInt(0);
      let otherValidators: ValidatorDelegation[] = [];
      let batch = 0;
      let end = false;
      
      // Process delegations in batches until we've fetched all
      while (!end) {
        const result = await this.contract.getDelegations(delegatorAddress, batch);
        const delegations = result.delegations;

        end = result.end;
        
        // Process each delegation in this batch
        for (const delegation of delegations) {
          const validatorAddress = delegation.account.toLowerCase();
          const stake = delegation.delegation.stake;
          const reward = delegation.delegation.rewards;
          
          if (validatorAddress === TARGET_VALIDATOR.toLowerCase()) {
            targetValidatorAmount += stake;
            targetValidatorRewards += reward;
          } else {
            otherValidatorsAmount += stake;
            
            // Store individual validator information for the dropdown
            otherValidators.push({
              address: validatorAddress,
              amount: stake,
              rewards: reward
            });
          }
        }
        
        batch++;
      }
      
      return {
        targetValidatorAmount,
        otherValidatorsAmount,
        targetValidatorRewards,
        otherValidators,
        isLoading: false
      };
    } catch (error) {
      console.error('Error fetching delegations:', error);
      throw error;
    }
  }
}

const DelegationService = new DelegationServiceClass();
export default DelegationService;